import { render } from "./user-email.svg?vue&type=template&id=e5b5804c"
const script = {}
script.render = render

export default script